import request from '@/utils/request'

export function requestAuthmail(param) {
    return request({
        url: '/v2/join/requestAuthmail',
        method: 'post',
        data: param
    })
}

export function isCheckAuthKey(param) {
    return request({
        url: '/v2/join/isCheckAuthKey',
        method: 'post',
        data: param
    })
}

export function confirmAuthmail(param) {
    return request({
        url: '/v2/join/confirmAuthmail',
        method: 'post',
        data: param
    })
}

export function isValid(param) {
    return request({
        url: '/v2/join/isValid',
        method: 'post',
        data: param
    })
}

export function createTempUser(param) {
    return request({
        url: '/v2/join/createTempUser',
        method: 'post',
        data: param
    })
}


export function createUser(params) {
    return request({
        url: '/v2/join/createUser',
        method: 'post',
        data: params
    })
}

export function orgNumSearchList(params) {
    return request({
        url: '/v2/join/orgNumSearchList',
        method: 'post',
        data: params
    })
}


export function changeMember(params) {
    return request({
        url: '/v2/join/changeMember',
        method: 'post',
        data: params
    })
}

export function isCheckAuthUser(params) {
  return request({
      url: '/v2/join/isCheckAuthUser',
      method: 'post',
      data: params
  })
}

export function changeUserAction(params) {
  return request({
      url: '/v2/join/changeUserAction',
      method: 'post',
      data: params
  })
}

export function checkAuthMail(params) {
  return request({
      url: '/v2/join/checkAuthMail',
      method: 'post',
      data: params
  })
}